import Common from './modules/common.js';
import ArchText from './modules/arch_text.js';
import NewsListHeight from './modules/news_list_height.js';
import ProductStickyHeight from './modules/product_sticky_height.js';

class App {
	constructor() {
		this.bodyTag = document.querySelector('body');

		this.routes();
  }

	routes() {
    this.common = new Common();

		if (document.querySelector('.p-index__class_band_bottom_intro')) {
			this.archText = new ArchText('.p-index__class_band_bottom_intro');
		}

		if (document.querySelector('.ol-news__body.ol-news__category-on')) {
			this.newsListHeight = new NewsListHeight();
		}

		if (document.querySelector('.ol-product__content-item .ol-product__image-sticky-wrapper')) {
			this.productStickyHeight = new ProductStickyHeight();
		}
	}
}

window.App = new App();
